import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ChangeRequestVO} from '../../../generate/TldChangeResultVO';


@Component({
    selector: 'summary-of-changes',
    templateUrl: './summary-of-changes.component.html',
    styleUrls: ['./summary-of-changes.component.scss'],
    standalone: false
})
export class SummaryOfChangesComponent implements OnChanges {

  @Input()
  changeRequest: ChangeRequestVO;

  @Input()
  showTicketNumbers: boolean;

  @Input()
  newDelegation: boolean;

  @Input()
  ticketNumber: string;

  allChanges = new Map<string, Array<string>>();
  changeKeys: Array<string> = [];

  constructor() { }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['changeRequest'] && this.changeRequest) {
      if (this.showTicketNumbers && !this.ticketNumber) {
        this.ticketNumber = this.changeRequest.id as string;
      }
      this.changeKeys = [];
      this.allChanges = new Map();
      if (this.changeRequest['changesHtml']) {
        this.allChanges = new Map(Object.entries(this.changeRequest['changesHtml']));
        this.allChanges.forEach((value: string[], key: string) => {
          this.changeKeys.push(key);
        });
      }
    }
  }

}
